import { StyleProp, View, ViewStyle } from "react-native";
import parseReactionAssetTemplateUrl from "src/helpers/parseV0TemplateUrl/parseReactionAssetTemplateUrl";
import { enumNever } from "src/shared/helpers/generalHelpers";
import { paddingSmall } from "src/styles/spacing";
import { Image, Text } from "src/swsh-native";
import { ReactionBadgeProps, ReactionBadgeSizeVariant } from "../types";

type SizeVariant = "sm" | "md" | "xxl";
const parseImageDim = (sizeVariant: SizeVariant) => {
	switch (sizeVariant) {
		case "sm":
			return {
				width: 16,
				height: 16,
			};
		case "md":
			return {
				width: 20,
				height: 20,
			};
		case "xxl":
			return {
				width: 160,
				height: 160,
			};
		default:
			return enumNever(sizeVariant);
	}
};
const parseFontSize = (sizeVariant: SizeVariant) => {
	switch (sizeVariant) {
		case "sm":
			return 10;
		case "md":
			return 16;
		case "xxl":
			return 120;
		default:
			return enumNever(sizeVariant);
	}
};

const ReactionAssetDisplay = ({
	sizeVariant,
	reactionAsset,
	style,
}: {
	sizeVariant: ReactionBadgeSizeVariant | "xxl";
	reactionAsset: ReactionBadgeProps["reactionAsset"];
	style?: StyleProp<ViewStyle>;
}) => {
	const url = parseReactionAssetTemplateUrl({ readUrl: reactionAsset?.url });

	if (url) {
		return (
			<Image
				alt="Reaction"
				dim={parseImageDim(sizeVariant)}
				src={url}
				contentFit="contain"
				style={style}
			/>
		);
	}
	return (
		<View style={style}>
			<Text
				style={{
					fontSize: parseFontSize(sizeVariant),
					// Fixing clipping issue
					paddingVertical: paddingSmall,
				}}
			>
				{reactionAsset?.emoji ?? "👍"}
			</Text>
		</View>
	);
};
export default ReactionAssetDisplay;
